"use client";

import { useTranslations } from "next-intl";
import { SignupFlowSlug } from "@./state";
import { useFlagVariant } from "libs/hooks/src";
import {
  SUF_V6_LAUNCH,
  SUF_PREFERENCE_QUESTIONS,
} from "apps/website/components/flows/fresh/sign-up/flags";
import { FormName } from "apps/website/types/form";
import type { IStep } from "../SimpleProgressSteps";

export const useSignupSteps = (): IStep[] => {
  const t = useTranslations("Forms.Fresh.SignUp.ProgressSteps");
  const isV6 = useFlagVariant(SUF_V6_LAUNCH, { formName: FormName.SIGN_UP_FRESH });
  const showPreferenceQuestions = useFlagVariant(SUF_PREFERENCE_QUESTIONS, { formName: FormName.SIGN_UP_FRESH });

  return [
    {
      label: t("myCats"),
      slugs: [
        SignupFlowSlug.CAT_COUNT,
        SignupFlowSlug.BASIC_INFORMATION,
        SignupFlowSlug.AGE,
        SignupFlowSlug.EATING_HABITS,
        ...(showPreferenceQuestions ? [ SignupFlowSlug.FLAVOURS, SignupFlowSlug.TEXTURES ] : []),
      ],
    },
    {
      label: t("health"),
      slugs: [
        SignupFlowSlug.FITNESS,
        SignupFlowSlug.WEIGHT,
        SignupFlowSlug.CURRENT_DIET,
        SignupFlowSlug.MEDICAL_CONDITIONS,
        SignupFlowSlug.ALLERGIES,
        SignupFlowSlug.MOTIVATION,
      ],
    },
    {
      label: t("myPlan"),
      slugs: [
        SignupFlowSlug.CAT_PARENT_DETAILS,
        SignupFlowSlug.RECIPES,
        SignupFlowSlug.WHY_FRESH,
        ...(isV6 ? [ SignupFlowSlug.PRICING ] : []),
      ],
    },
    {
      label: t("checkout"),
      slugs: [
        ...(isV6 ? [] : [ SignupFlowSlug.PRICING ]),
        SignupFlowSlug.TREATS,
        SignupFlowSlug.CHECKOUT,
      ],
    },
  ];
};
